import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'role', label: 'Role / Designation', type: 'text' },
    { key: 'bio', label: 'Short bio', type: 'textarea' },
    { key: 'photo_url', label: 'Photo', type: 'upload-image', prefix: 'advisors' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'name', label: 'Name', primary: true },
    { key: 'role', label: 'Role' },
    { key: 'order', label: 'Order' },
];

const defaultItem = { name: '', role: '', bio: '', photo_url: '', order: 99 };

export default function AdminAdvisorsPage() {
    return (
        <CrudManager
            resource="advisors"
            title="Advisory Committee"
            description="Advisors listed on the About Us page."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['name', 'role']}
        />
    );
}
